import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Paper from '@material-ui/core/Paper';
import { useTheme, experimentalStyled as styled } from '@material-ui/core/styles';
import TimeIcon from '../internal/svg-icons/Time';
import DateRangeIcon from '../internal/svg-icons/DateRange';
import { WrapperVariantContext } from '../internal/pickers/wrappers/WrapperVariantContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const viewToTab = openView => {
  // TODO: what happens if `openView` is `month`?
  if (openView === 'day' || openView === 'year') {
    return 'date';
  }

  return 'time';
};

const tabToView = tab => {
  if (tab === 'date') {
    return 'day';
  }

  return 'hours';
};

const DateTimePickerTabsRoot = styled(Paper, {}, {
  skipSx: true
})(({
  styleProps = {}
}) => _extends({}, styleProps.wrapperVariant === 'desktop' && {
  order: 1
}));
const DateTimePickerTabsTabs = styled(Tabs, {}, {
  skipSx: true
})(({
  theme
}) => {
  const tabsBackground = theme.palette.mode === 'light' ? theme.palette.primary.main : theme.palette.background.default;
  return {
    color: theme.palette.getContrastText(tabsBackground),
    backgroundColor: tabsBackground
  };
});
/**
 * @ignore - internal component.
 */

var _ref = /*#__PURE__*/_jsx(DateRangeIcon, {});

var _ref2 = /*#__PURE__*/_jsx(TimeIcon, {});

const DateTimePickerTabs = props => {
  const {
    dateRangeIcon = _ref,
    onChange,
    timeIcon = _ref2,
    view
  } = props;
  const theme = useTheme();
  const wrapperVariant = React.useContext(WrapperVariantContext);
  const indicatorColor = theme.palette.mode === 'light' ? 'secondary' : 'primary';

  const styleProps = _extends({}, props, {
    wrapperVariant
  });

  const handleChange = (event, value) => {
    onChange(tabToView(value));
  };

  return /*#__PURE__*/_jsx(DateTimePickerTabsRoot, {
    styleProps: styleProps,
    children: /*#__PURE__*/_jsxs(DateTimePickerTabsTabs, {
      variant: "fullWidth",
      value: viewToTab(view),
      onChange: handleChange,
      indicatorColor: indicatorColor,
      children: [/*#__PURE__*/_jsx(Tab, {
        value: "date",
        "aria-label": "pick date",
        icon: /*#__PURE__*/_jsx(React.Fragment, {
          children: dateRangeIcon
        })
      }), /*#__PURE__*/_jsx(Tab, {
        value: "time",
        "aria-label": "pick time",
        icon: /*#__PURE__*/_jsx(React.Fragment, {
          children: timeIcon
        })
      })]
    })
  });
};

export default DateTimePickerTabs;